/* Validated content adapter. Components keep a stable import surface while
 * Decap edits the JSON files under src/content. */

import {
  activeOfferFor,
  galleryContent,
  homepageContent,
  offersContent,
  productsContent,
  siteContent,
  testimonialsContent
} from '../content';

export const brandAssets = {
  logo: siteContent.brand.logo,
  logoLegacy: siteContent.brand.logoLegacy,
  hero: homepageContent.hero.poster,
  heroSecondary: '/images/kriams/brownie-slab-logo.jpg',
  order: '/images/kriams/ribbon-gift-box.jpg',
  aboutMain: homepageContent.founderStory.mainImage,
  aboutFloat: homepageContent.founderStory.floatImage
};

const announcementOffer = activeOfferFor(offersContent, 'announcement');

export { activeOfferFor, homepageContent, offersContent, siteContent };

export const siteSettings = {
  ...siteContent.contact,
  ...siteContent.ordering,
  ...siteContent.legal,
  announcement: announcementOffer?.announcement || '',
  announcementCta: announcementOffer?.ctaLabel || '',
  announcementStart: announcementOffer?.startsAt || '',
  announcementEnd: announcementOffer?.endsAt || ''
};
export const whatsappNumber = siteContent.contact.whatsappNumber;
export const orderLink = `https://wa.me/${whatsappNumber}`;
export const instagramUrl = siteContent.contact.instagramUrl;

export const products = productsContent;

export const availabilityOptions = {
  fresh: { label: 'Fresh batch', tone: 'fresh' },
  'made-to-order': { label: 'Made to order', tone: 'order' },
  preorder: { label: 'Pre-order', tone: 'preorder' },
  'sold-out': { label: 'Sold out', tone: 'soldout' }
};

export const getProductAvailability = (product) =>
  availabilityOptions[product?.availability] || availabilityOptions['made-to-order'];

export const canAddToCart = (product) =>
  Boolean(product && product.active !== false && !product.orderOnly && product.availability !== 'sold-out');

export const getProductVariant = (product, variantId) =>
  product?.variants?.find((variant) => variant.id === variantId) || null;

export const defaultVariantId = (product) =>
  product?.price == null ? product?.variants?.[0]?.id || '' : '';

/* A variant is a distinct order line: it keeps the customer's selected size or
 * flavour and its own price all the way through the cart and WhatsApp handoff. */
export const toOrderProduct = (product, variantId = '') => {
  const variant = getProductVariant(product, variantId);
  if (!variant) return { ...product, variantId: '', variantName: '', variant: null };
  const priceOnRequest = Boolean(variant.priceOnRequest || variant.price == null);
  return {
    ...product,
    name: `${product.name} - ${variant.name}`,
    price: priceOnRequest ? null : variant.price,
    priceOnRequest,
    priceLabel: priceOnRequest ? 'Price on request' : '',
    variantId: variant.id,
    variantName: variant.name,
    variant
  };
};

export const categories = siteContent.catalog.categories;

export const galleryImages = galleryContent.images;
export const testimonials = testimonialsContent.testimonials;
